import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { CreatePricingPlanFormSchemaValues as FormSchemaValues } from 'src/features/pricingPlans/api/useCreatePricingPlan';
import type { PricingPlanDetails } from 'src/features/pricingPlans/types';

const RESOURCE = '/parkings/:parkingId/pricing-plans/normal/:planId/';

interface DTO extends FormSchemaValues {
    parkingId: string;
    planId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, planId, ...data }: DTO): Promise<PricingPlanDetails> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, planId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as UPDATE_PRICING_PLAN_RESOURCE, useMutationHook as useUpdatePricingPlan };
export type { DTO as UpdatePricingPlanDTO, FormSchemaValues as UpdatePricingPlanFormSchemaValues };
